import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import Swal from 'sweetalert2';
import { G_Warehouse_Viewmodel } from 'src/app/viewmodels/g-settings/G_Warehouse_Viewmodel';
import { SaveGWarehouseRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-warehouse-form',
  templateUrl: './warehouse-form.component.html',
  styleUrls: ['./warehouse-form.component.scss']
})
export class WarehouseFormComponent implements OnInit {

  @Input() public vm: SaveGWarehouseRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    // console.log(this.vmlist);
    if (this.vm == undefined) {
      this.vm = new SaveGWarehouseRequest();
    }
    if (this.modal_title == undefined) {
      this.modal_title = "Warehouse";
    }
  }

  saveOrUpdate() {
    this.spinner.show();
    this._uow.gSettingService
      .SaveGWarehouseAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.bsmRef.hide();
        this.spinner.hide();
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )
      })
      .catch((error) => {
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        this.spinner.hide();
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
      });
  }

  checkwarehouseDublication(tagName) {
    this._jq.showSpinner(true);
    this._uow.warehouseService.checkDublication(tagName).toPromise().then((res: any) => {
      if (res === true) {
        this.IsDublicate = false;
      } else {
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  openTagTypeModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
  }

  onFuelTypeSubmitted(e) {
    if (e == true) {
      this.modalRef.hide();
      this.ngOnInit();
    }
  }
}
